module.exports = __webpack_public_path__ + "img/ilawyer-logo.3bb9eab3.png";